// Mock data for Grey Matter Innovations landing page

export const companyInfo = {
  name: "Grey Matter Innovations",
  tagline: "Cost-Effective Home Solutions & General Maintenance",
  phone: "740-644-6065",
  email: "tconley0212@gmail.com",
  serviceArea: "Central Ohio",
  ownerName: "Travis Conley",
  yearsExperience: "10+",
  facebook: "https://facebook.com/greymatterinnovations",
  domain: "www.greymatterinnovations.com"
};

export const services = [
  {
    id: 1,
    title: "Deck Construction & Repair",
    description: "Custom deck building and repairs using pressure-treated wood or composite materials. Create the perfect outdoor living space for your home.",
    icon: "Layers"
  },
  {
    id: 2,
    title: "Power Washing",
    description: "Professional exterior cleaning to restore your home's curb appeal. We remove dirt, grime, and mildew from siding, driveways, and decks.",
    icon: "Droplets"
  },
  {
    id: 3,
    title: "Gutter Services",
    description: "Complete gutter cleaning and gutter guard installation to protect your home from water damage year-round.",
    icon: "Home"
  },
  {
    id: 4,
    title: "Painting Services",
    description: "Interior and exterior painting to refresh your home's appearance with quality materials and expert craftsmanship.",
    icon: "PaintBucket"
  },
  {
    id: 5,
    title: "Minor Exterior Repairs",
    description: "From siding repairs to trim work, we handle all your minor exterior maintenance needs with precision.",
    icon: "Wrench"
  },
  {
    id: 6,
    title: "General Demo & Junk Removal",
    description: "Efficient demolition and junk removal services to clear your space for new projects or simply declutter.",
    icon: "Trash2"
  },
  {
    id: 7,
    title: "General Maintenance",
    description: "Comprehensive home maintenance services to keep your property in top condition throughout the year.",
    icon: "Settings"
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "10+ Years Experience",
    description: "Over a decade of expertise in residential construction and exterior restoration.",
    icon: "Award"
  },
  {
    id: 2,
    title: "Community-Focused",
    description: "Proudly serving Central Ohio families with personalized, neighborly service.",
    icon: "Users"
  },
  {
    id: 3,
    title: "Cost-Effective Solutions",
    description: "Quality workmanship at fair prices, with free on-site evaluations.",
    icon: "DollarSign"
  },
  {
    id: 4,
    title: "Expert Craftsmanship",
    description: "Specialized in exterior restoration with attention to every detail.",
    icon: "CheckCircle"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah M.",
    location: "Columbus, OH",
    text: "Travis and his team did an amazing job power washing our home and sealing our driveway. Very professional and reasonably priced!",
    rating: 5
  },
  {
    id: 2,
    name: "Mike R.",
    location: "Delaware, OH",
    text: "Best gutter cleaning service we've used. Travis was thorough and even installed gutter guards. Highly recommend!",
    rating: 5
  },
  {
    id: 3,
    name: "Jennifer L.",
    location: "Worthington, OH",
    text: "Grey Matter Innovations helped us with several exterior repairs. Great communication and quality work throughout.",
    rating: 5
  }
];
